import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import SignupClient from '../views/SignupClient.vue'
import SignupHealthCare from '../views/SignupHealthCare.vue'
import Landing from '../views/Landing.vue'
import SecretaryAuditLogs from '../views/SecretaryAuditLogs.vue'
import SecretaryUsers from '../views/SecretaryUsers.vue'
import ServiceProviderLogs from '../views/ServiceProviderLogs.vue'


import ForgotPassword from '../views/ForgotPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import UserNotes from '../views/UserNotes.vue'
import RegistrationComplete from '../views/RegistrationComplete.vue'
import VerifyUser from '../views/VerifyUser.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import store from '../store'




Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter (to, from, next) {
      if (!store.getters.isAuthenticated) {
        // TODO: Find much better way to handle this
        if (from.name === 'Login') {
          next('/login')  
        } else {
          next('/landing')
        }
        
      } else {
        next()
      }
    }
  },
  {
    path: '/user_notes',
    name: 'UserNotes',
    component: UserNotes,
    beforeEnter (to, from, next) {
      if (!store.getters.isServiceProvider) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/users',
    name: 'SecretaryUsers',
    component: SecretaryUsers,
    beforeEnter (to, from, next) {
      if (!store.getters.isSecretary) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/audit_logs',
    name: 'SecretaryAuditLogs',
    component: SecretaryAuditLogs,
    beforeEnter (to, from, next) {
      if (!store.getters.isSecretary) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/provider_logs',
    name: 'ServiceProviderLogs',
    component: ServiceProviderLogs,
    beforeEnter (to, from, next) {
      if (!store.getters.isServiceProvider) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/verify_user',
    name: 'VerifyUser',
    component: VerifyUser
  },
  {
    path: '/registration_complete',
    name: 'RegistrationComplete',
    component: RegistrationComplete
  },
  {
    path: '/signup_client',
    name: 'SignupClient',
    component: SignupClient
  },
  {
    path: '/signup_health_care',
    name: 'SignupHealthCare',
    component: SignupHealthCare
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset_password/:token',
    name: 'ResetPassword',
    component: ResetPassword
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
